import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getEwalletLogAll(params) {
	return client.get("ewallet/history", {
		params: params,
	});
}

function getEwalletLogIn(params) {
	return client.get("ewallet/history/in", {
		params: params,
	});
}

function getEwalletLogOut(params) {
	return client.get("ewallet/history/out", {
		params: params,
	});
}

function getEwalletSummary(params) {
	return client.get("ewallet/summary", {
		params: params,
	});
}

function getHistoriTransfer(params) {
	return client.get("ewallet/history-transfer", {
		params: params,
	});
}

function transferEwallet(params) {
	return client.post("ewallet/transfer", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getAutocompleteMitra(params) {
	return client.get("ewallet/autocomplete", {
		params: params,
	});
}

function checkPinPramitra(params) {
	return client.get("membership/personal/check-pin", {
		params: params,
	});
}

function checkPinMitra(params) {
	return client.get("binary/personal/check-pin", {
		params: params,
	});
}

function setPinMitra(params) {
	return client.post("binary/personal/edit-pin", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function setPinPramitra(params) {
	return client.post("membership/personal/edit-pin", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getEwalletLogAll,
	getEwalletLogIn,
	getEwalletLogOut,
	getEwalletSummary,
	getHistoriTransfer,
	transferEwallet,
	getAutocompleteMitra,
	checkPinPramitra,
	checkPinMitra,
	setPinMitra,
	setPinPramitra
};